export function parseZplLabelSizeInches(
  zpl: string,
  dpi: number,
): { widthInches: number; heightInches: number } | null {
  if (!(dpi > 0) || zpl.trim() === "") return null;
  const widthDots = /\^PW(\d+)/i.exec(zpl);
  const heightDots = /\^LL(\d+)/i.exec(zpl);
  if (widthDots == null || heightDots == null) return null;
  const widthInches = Number(widthDots[1]) / dpi;
  const heightInches = Number(heightDots[1]) / dpi;
  if (!(widthInches > 0) || !(heightInches > 0)) return null;
  return { widthInches, heightInches };
}

export function parseLabelSizeCaption(caption: string | null | undefined): {
  widthInches: number;
  heightInches: number;
} | null {
  const match = /^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(caption?.trim() ?? "");
  if (match == null) return null;
  const widthInches = Number(match[1]);
  const heightInches = Number(match[2]);
  if (!(widthInches > 0) || !(heightInches > 0)) return null;
  return { widthInches, heightInches };
}

export function parseLabelTemplateSampleDataText(text: string): Record<string, unknown> {
  const trimmed = text.trim();
  if (trimmed === "") {
    throw new Error("Sample data JSON is empty.");
  }
  const parsed: unknown = JSON.parse(trimmed);
  if (parsed == null || typeof parsed !== "object" || Array.isArray(parsed)) {
    throw new Error("Sample data must be a JSON object.");
  }
  return parsed as Record<string, unknown>;
}

export function formatLabelTemplateSampleData(data: Record<string, unknown>): string {
  return JSON.stringify(data, null, 2);
}

/** Demo SKU used when opening a hub-box template — loaded from catalog, not canned accessories. */
export function defaultHubBoxPreviewSku(productFamily: string): string | null {
  const family = productFamily.trim();
  if (family === "FI-3C/5A" || family === "FI-3C") return "FI-3C S08BAM-DOMVA";
  if (family === "FI-5A-W") return "FI-5A-W-3 H";
  if (family === "FI-5A") return "FI-5A S24TNB-Z";
  return null;
}
